module.exports = __webpack_public_path__ + "static/media/16. Computer Book PDF.3a5d6064.pdf";